module.exports = __webpack_public_path__ + "static/media/Subtract 1.958eb9cb.png";